/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { createAdminModelSchema } from "../createAdminModelSchema.ts";
import { guidCreatedOrUpdatedEntityModelSchema } from "../guidCreatedOrUpdatedEntityModelSchema.ts";
import { z } from "zod";

/**
 * @description Администратор создан
 */
export const postApiAdmins200Schema = z.lazy(() => guidCreatedOrUpdatedEntityModelSchema)

/**
 * @description Администратор с таким логином уже существует | Ошибка валидации
 */
export const postApiAdmins400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiAdmins401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiAdmins403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiAdmins500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const postApiAdminsMutationRequestSchema = z.lazy(() => createAdminModelSchema).describe("Тело запроса")

export const postApiAdminsMutationResponseSchema = z.lazy(() => postApiAdmins200Schema)